import React from 'react';
import styles from '../landing.module.scss';

// Import icons
import iconKeyword from '../../../assets/images/landing/icon-keyword.svg';
import iconCompare from '../../../assets/images/landing/icon-compare.svg';
import iconDaily from '../../../assets/images/landing/icon-daily.svg';
import iconCustom from '../../../assets/images/landing/icon-custom.svg';
import iconAi from '../../../assets/images/landing/icon-ai.svg';
import iconApp from '../../../assets/images/landing/icon-app.svg';

const WhyChooseKeyQuest = () => {
    const features = [
        {
            title: "Keyword Tracking",
            description: "Monitor and analyze keyword performance over time.",
            icon: iconKeyword
        },
        {
            title: "App Comparison",
            description: "Compare app performance and gain a competitive edge.",
            icon: iconCompare
        },
        {
            title: "Daily Reports",
            description: "Stay informed with automated daily data updates.",
            icon: iconDaily
        },
        {
            title: "Custom Insights",
            description: "Tailor analytics to meet your specific business needs.",
            icon: iconCustom
        },
        {
            title: "AI Reports",
            description: "Leverage artificial intelligence for predictive insights and trend analysis.",
            icon: iconAi
        },
        {
            title: "App Tracking",
            description: "Keep track of app metrics, performance, and user engagement.",
            icon: iconApp
        }
    ];

    return (
        <section className={styles.whyChooseSection}>
            <div className={styles.container}>
                <h2 className={styles.sectionTitle}>Why Choose KeyQuest?</h2>
                <div className={styles.featuresGrid}>
                    {features.map((feature, index) => (
                        <div key={index} className={styles.featureCard}>
                            <div className={styles.iconWrapper}>
                                <img src={feature.icon} alt={feature.title} />
                            </div>
                            <div className={styles.cardContent}>
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseKeyQuest;
